import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferralFromUrl } from '../utils/referralStorage';

/** Persists ?ref=CODE from the URL for signup attribution. */
export default function ReferralCapture() {
  const location = useLocation();

  useEffect(() => {
    captureReferralFromUrl();
  }, [location.search]);

  return null;
}
